/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_use_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provide, operate, and maintain our tools and services`)
};

const es_privacy_use_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveer, operar y mantener nuestras herramientas y servicios`)
};

const de_privacy_use_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Werkzeuge und Dienste bereitzustellen, zu betreiben und zu warten`)
};

const nl_privacy_use_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze tools en diensten aan te bieden, te beheren en te onderhouden`)
};

const fr_privacy_use_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournir, exploiter et maintenir nos outils et services`)
};

const it_privacy_use_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornire, gestire e mantenere i nostri strumenti e servizi`)
};

const pt_br2_privacy_use_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornecer, operar e manter nossas ferramentas e serviços`)
};

const pt_privacy_use_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornecer, operar e manter as nossas ferramentas e serviços`)
};

const ja_privacy_use_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツールとサービスの提供、運営、維持`)
};

const zh_privacy_use_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提供、运营和维护我们的工具和服务`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_use_1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_use_1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_use_1", locale)
	if (locale === "en") return en_privacy_use_1(inputs)
	if (locale === "es") return es_privacy_use_1(inputs)
	if (locale === "de") return de_privacy_use_1(inputs)
	if (locale === "nl") return nl_privacy_use_1(inputs)
	if (locale === "fr") return fr_privacy_use_1(inputs)
	if (locale === "it") return it_privacy_use_1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_use_1(inputs)
	if (locale === "pt") return pt_privacy_use_1(inputs)
	if (locale === "ja") return ja_privacy_use_1(inputs)
	return zh_privacy_use_1(inputs)
};